export type Outcome<T, E> =
    | {
          value: T;
          problem?: undefined;
          crash?: undefined;
      }
    | {
          value?: undefined;
          problem: E;
          crash?: undefined;
      }
    | {
          value?: undefined;
          problem?: undefined;
          crash: unknown;
      };

export function Outcome<O extends Outcome<any, any>>(outcome: O) {
    return outcome;
}

export type Future<V, E = unknown> =
    | {
          pending: true;
          ok?: false | undefined;
          value?: undefined;
          error?: undefined;
      }
    | {
          ok: true;
          value: V;
          pending?: false | undefined;
      }
    | {
          ok: false;
          error: E;
          pending?: false | undefined;
      };

export function Future<T>(future: Future<T>) {
    return future;
}

Future.pending = <T>(): Future<T> => ({
    pending: true,
});
Future.success = <T>(value: T): Future<T> => ({
    ok: true,
    value,
});
Future.failure = <T>(error: Error): Future<T> => ({
    ok: false,
    error,
});
